import qs from "qs";

export const generateSupportURL = (
  location,
  reason,
  destination,
  subDestination
) => {
  const query =
    reason || destination || subDestination
      ? `?${qs.stringify({
          destination,
          reason,
          subDestination,
        })}`
      : "";
  return `/${location}/support${query}`;
};
